export const GOOGLE_MAPS_LIBRARIES: ("geometry" | "places")[] = ["geometry", "places"];
export const GOOGLE_MAPS_SCRIPT_ID = "google-map-script";
